import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { forwardRef, useContext } from 'react';
import styled from 'foundations-theming/utils';
import { DialogContext } from '../Dialog/DialogContext';
import { LabelWrapper } from '../FormControl/FormControl';
import { ConfirmDialogContext } from '../ConfirmDialog/ConfirmDialogContext';
import { WizardContext } from '../Wizard/WizardProvider';
import { deepMerge } from '../../utils/deepMerge/deepMerge';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { BREAKPOINTS } from '../Grid/Grid.types';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledDialogBody = styled.div.withConfig({
  displayName: "DialogBody__StyledDialogBody",
  componentId: "sc-6zx38t-0"
})(({
  $cssStyles,
  theme,
  $styleOverrides
}) => {
  const isConversational = useContext(DialogContext).use === 'conversational';
  const isInfo = useContext(DialogContext).use === 'info';
  const isUpgrades = useContext(DialogContext).use === 'upgrades';
  const isConfirmDialog = useContext(ConfirmDialogContext).isConfirmDialog;
  const isDanger = useContext(DialogContext).use === 'danger';
  const isFullScreen = useContext(DialogContext).use === 'fullscreen';
  const isDefault = useContext(DialogContext).use === 'default';
  const getPaddingBlockStart = () => {
    if (isFullScreen) {
      return undefined;
    }
    if (!isConversational && !isConfirmDialog || isDanger) {
      return theme.space['600'];
    }
    if (isConfirmDialog && !isConversational) {
      return theme.space['600'];
    }
    return theme.space['0'];
  };
  return deepMerge({
    [`${LabelWrapper}`]: {
      textAlign: isConversational || isInfo || isUpgrades ? 'center' : undefined
    },
    textAlign: isConversational || isInfo || isUpgrades ? 'center' : undefined,
    backgroundColor: theme.color['fill-surface-default'],
    justifyContent: isConversational || isInfo || isUpgrades ? 'center' : undefined,
    padding: theme.space['1000'],
    paddingBlockEnd: !isConversational ? theme.space['25'] : undefined,
    paddingBlockStart: getPaddingBlockStart(),
    borderStartStartRadius: isDefault ? theme.borderRadius['transitional-floating'] : undefined,
    borderStartEndRadius: isDefault ? theme.borderRadius['transitional-floating'] : undefined,
    overflowY: 'auto',
    flexGrow: 1,
    flexShrink: 1,
    '&': {
      [`@media only screen and (max-width: ${BREAKPOINTS.sm}px)`]: {
        height: '100%'
      }
    },
    // replaces the `has--vertical-spacing` className styling
    '& > :last-child': {
      marginBottom: theme.space['0']
    },
    '&&': Object.assign({}, $cssStyles)
  }, $styleOverrides);
});
export const DialogBody = /*#__PURE__*/forwardRef((_ref, ref) => {
  var _wizardContext$dialog;
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const wizardContext = useContext(WizardContext);
  return /*#__PURE__*/_jsx(StyledDialogBody, Object.assign({
    ref: ref,
    $cssStyles: cssStyles,
    $styleOverrides: (_wizardContext$dialog = wizardContext === null || wizardContext === void 0 ? void 0 : wizardContext.dialogBodyStyleOverrides) !== null && _wizardContext$dialog !== void 0 ? _wizardContext$dialog : {}
  }, domProps, {
    children: children
  }));
});